import React from 'react';
import Icon from '../components/Icon';
import Reveal from '../components/Reveal';
import BRWStrip from '../components/BRWStrip';
import useSeo from '../hooks/useSeo';
import { IMAGES, ABOUT_APPROACH } from '../mock';

const About = () => {
  useSeo({
    title: 'About Duffy Investment Group | Global Investment Experience',
    description: 'Discover Duffy Investment Group, a boutique investment firm drawing on extensive international business and investment experience across diverse industries.',
    keywords: 'Duffy Investment Group, investment experience, global investment experience, boutique investment firm, private investment, international investments',
  });

  return (
    <div>
      {/* ===================== HERO ===================== */}
      <section className="relative overflow-hidden">
        <div className="grid lg:grid-cols-2">
          {/* Text panel */}
          <div className="bg-cream flex items-center order-2 lg:order-1">
            <div className="px-6 sm:px-12 py-16 lg:py-24 max-w-xl ml-auto lg:ml-0">
              <Reveal>
                <h1 className="font-serif-dig" style={{ fontSize: 'clamp(1.75rem, 6vw, 3rem)', fontWeight: 700, lineHeight: 1.15, color: 'var(--navy)' }}>
                  A HANDS-ON APPROACH <span className="gold-text">TO INVESTMENT</span>
                </h1>
                <span className="gold-rule-lg block mt-6 mb-7" />
              </Reveal>
              <Reveal delay={120}>
                <p className="font-body" style={{ color: 'var(--ink)', fontSize: '1.05rem', lineHeight: 1.75 }}>
                  Duffy Investment Group (DIG) is a boutique investment firm that combines global vision with local knowledge.
                </p>
                <p className="font-body mt-5" style={{ color: 'var(--muted)', fontSize: '1.05rem', lineHeight: 1.75 }}>
                  Best described as a technology research and development investor, our interests extend across a range of sectors including casino gaming, property and entertainment.
                </p>
              </Reveal>
            </div>
          </div>

          {/* Portrait */}
          <div className="relative bg-navy order-1 lg:order-2 min-h-[440px]">
            <img src={IMAGES.executivePortrait} alt="Craig Duffy" className="absolute inset-0 w-full h-full craig-hero-img" />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg, rgba(7,19,34,0.6) 0%, rgba(7,19,34,0) 45%)' }} />
            <div className="hero-br-tint" />
            <div className="absolute" style={{ bottom: 28, right: 28 }}>
              <div className="text-right" style={{ textShadow: '0 2px 14px rgba(0,0,0,0.9)' }}>
                <p className="font-serif-dig text-white" style={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '0.04em' }}>CRAIG DUFFY</p>
                <p className="font-body gold-text">Executive Chairman</p>
                <p className="font-body" style={{ color: 'rgba(255,255,255,0.9)' }}>Duffy Investment Group</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===================== OUR APPROACH ===================== */}
      <section className="bg-cream">
        <div className="dig-container py-16 md:py-20">
          <Reveal className="text-center">
            <h2 className="section-title" style={{ fontSize: 'clamp(1.7rem, 3vw, 2.2rem)' }}>OUR APPROACH</h2>
            <span className="gold-rule block mx-auto mt-4" />
          </Reveal>
          <div className="grid md:grid-cols-3 gap-12 mt-14">
            {ABOUT_APPROACH.map((a, i) => (
              <Reveal key={a.title} delay={i * 120} className="flex flex-col items-center text-center">
                <div className="grid place-items-center rounded-full" style={{ width: 82, height: 82, background: 'var(--navy)' }}>
                  <Icon name={a.icon} size={34} strokeWidth={1.4} style={{ color: 'var(--gold)' }} />
                </div>
                <h3 className="font-serif-dig navy-text mt-5" style={{ fontWeight: 700, fontSize: '1.2rem', letterSpacing: '0.04em' }}>{a.title}</h3>
                <p className="font-body mt-3" style={{ color: 'var(--muted)', lineHeight: 1.7, maxWidth: 260 }}>{a.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ===================== GLOBAL BAND ===================== */}
      <section className="bg-navy-grad relative overflow-hidden">
        <div
          className="absolute inset-y-0 right-0 hidden md:block"
          style={{
            width: '45%',
            backgroundImage: 'radial-gradient(rgba(200,162,76,0.5) 1.4px, transparent 1.6px)',
            backgroundSize: '16px 16px',
            opacity: 0.5,
            maskImage: 'linear-gradient(90deg, transparent, #000 40%)',
            WebkitMaskImage: 'linear-gradient(90deg, transparent, #000 40%)',
          }}
        />
        <div className="dig-container py-14 relative">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 max-w-3xl">
            <Icon name="Globe" size={64} strokeWidth={1} style={{ color: 'var(--gold)', flexShrink: 0 }} />
            <div>
              <h3 className="font-serif-dig gold-text" style={{ fontSize: '1.5rem', fontWeight: 700 }}>GLOBAL EXPERIENCE. PROVEN RESULTS.</h3>
              <p className="font-body mt-3" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.75, fontSize: '1.05rem' }}>
                Having commercialised many successful investments all over the world, our products have been successfully sold in 22 countries – and counting.
              </p>
            </div>
          </div>
        </div>
      </section>

      <BRWStrip />
    </div>
  );
};

export default About;
